var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkshopDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5C0.75 3.20507 2.20507 1.75 4 1.75H16C17.7949 1.75 19.25 3.20507 19.25 5V16C19.25 17.7949 17.7949 19.25 16 19.25H4C2.20507 19.25 0.75 17.7949 0.75 16V5Z",
    fill: "white",
    stroke: "#5F6272",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8 0C6.24183 0 6.6 0.288848 6.6 0.645161V3.54839C6.6 3.9047 6.24183 4.19355 5.8 4.19355C5.35817 4.19355 5 3.9047 5 3.54839V0.645161C5 0.288848 5.35817 0 5.8 0Z",
    fill: "#5F6272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6086 0C15.0504 0 15.4086 0.288848 15.4086 0.645161V3.54839C15.4086 3.9047 15.0504 4.19355 14.6086 4.19355C14.1668 4.19355 13.8086 3.9047 13.8086 3.54839V0.645161C13.8086 0.288848 14.1668 0 14.6086 0Z",
    fill: "#5F6272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 9H1V7H19V9Z",
    fill: "#5F6272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3226C6 11.8749 5.55228 12.3226 5 12.3226C4.44772 12.3226 4 11.8749 4 11.3226C4 10.7703 4.44772 10.3226 5 10.3226C5.55228 10.3226 6 10.7703 6 11.3226Z",
    fill: "#5F6272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.3226C11 11.8749 10.5523 12.3226 10 12.3226C9.44772 12.3226 9 11.8749 9 11.3226C9 10.7703 9.44772 10.3226 10 10.3226C10.5523 10.3226 11 10.7703 11 11.3226Z",
    fill: "#5F6272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.3226C16 11.8749 15.5523 12.3226 15 12.3226C14.4477 12.3226 14 11.8749 14 11.3226C14 10.7703 14.4477 10.3226 15 10.3226C15.5523 10.3226 16 10.7703 16 11.3226Z",
    fill: "#5F6272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.3226C6 15.8749 5.55228 16.3226 5 16.3226C4.44772 16.3226 4 15.8749 4 15.3226C4 14.7703 4.44772 14.3226 5 14.3226C5.55228 14.3226 6 14.7703 6 15.3226Z",
    fill: "#5F6272"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.3226C11 15.8749 10.5523 16.3226 10 16.3226C9.44772 16.3226 9 15.8749 9 15.3226C9 14.7703 9.44772 14.3226 10 14.3226C10.5523 14.3226 11 14.7703 11 15.3226Z",
    fill: "#5F6272"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.3226C16 15.8749 15.5523 16.3226 15 16.3226C14.4477 16.3226 14 15.8749 14 15.3226C14 14.7703 14.4477 14.3226 15 14.3226C15.5523 14.3226 16 14.7703 16 15.3226Z",
    fill: "#5F6272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopDateIcon);
export default __webpack_public_path__ + "static/media/WorkshopDateIcon.575c4aece265ead7cfc12475a4302525.svg";
export { ForwardRef as ReactComponent };